"use strict";

document.getElementById("play-video").onclick = function () {
  if (window.screen.width >= 900) {
    document.getElementById("video").innerHTML =
    '<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/OIxrsHIpNkE?si=x0jWujps7InC6HFB&autoplay=1&mute=1" title="Bookable" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>'
  } else {
    document.getElementById("video").innerHTML =
      '<iframe width="350" height="197" src="https://www.youtube-nocookie.com/embed/OIxrsHIpNkE?si=x0jWujps7InC6HFB&autoplay=1&mute=1" title="Bookable" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
  }
};
